import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'; // Add this import for navigation
import emailjs from 'emailjs-com'; // Add this import for email sending

// Import the image properly (adjust path if needed based on your project structure)

const DEFAULT_DOCTOR = "AI Physician";

class HealthChatbot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTars: true, // Always show TARS
    };
    this.tarsScript = null; // Reference for TARS widget script
  }

  // --- Lifecycle Methods ---
  componentDidMount() {
    // Load TARS widget immediately
    this.loadTarsWidget();
    
  }

  componentWillUnmount() {
    // Remove TARS widget script if loaded
    if (this.tarsScript) {
      document.head.removeChild(this.tarsScript);
      this.tarsScript = null;
    }
  }

  // Load TARS widget using the provided code
 loadTarsWidget = () => {
  if (document.getElementById('tars-widget-script')) return;

  window.tarsSettings = { "convid": "BTYEo3" };

  const script = document.createElement('script');
  script.id = "tars-widget-script";
  script.type = "text/javascript";
  script.src = "https://tars-file-upload.s3.amazonaws.com/bulb/js/widget.js";

  // Create the global function
  window.openHealthChat = (e) => {
    if (e) e.preventDefault();

    // Check if TARS is ready
    if (window.TARS) {
      window.TARS.open();
    } else {
      // If not ready yet, try to wait 500ms and try again automatically
      console.log("TARS not ready, retrying...");
      setTimeout(() => {
        if (window.TARS) window.TARS.open();
      }, 500);
    }
  };

  document.head.appendChild(script);
  this.tarsScript = script;
};

  // --- Main Render Method ---
  render() {
    // TARS widget will handle its own icon in the corner and the entire chat interface, including collecting basic details if configured in TARS.
    // No custom UI needed; TARS overlays everything.
    return null; // Or <div></div> if needed, but TARS manages its own DOM.
  }
}

export default withRouter(HealthChatbot);